import api from './api';
import { getExhibitorIcon } from './StorageService';
import { Response, Exhibitor, ExhibitorVoucher, VoucherType, ExhibitorVoucherBalance, Balance } from '../dtos';

const findAllExhibitors = async (): Promise<Exhibitor[]> => {
    const { data } = await api.get<Response<ExhibitorVoucher[]>>('vouchers-available');

    if (Object.keys(data).length === 0)
        return [];

    const exhibitors = data.data.reduce((exhibitors, exhibitorVoucher) => {
        const { exhibitorId, exhibitorUuid, exhibitorName, voucherTypeId, voucherTypeName, amount } = exhibitorVoucher;

        const voucherType: VoucherType = {
            id: voucherTypeId,
            name: voucherTypeName,
            amount: amount < 0 ? 0 : amount
        };

        const index = exhibitors.findIndex(exhibitor => exhibitor.id === exhibitorId);

        if (index !== -1) {
            const exhibitor = exhibitors[index];

            exhibitors[index] = {
                ...exhibitor,
                voucherTypes: [...exhibitor.voucherTypes, voucherType]
            };
        } else {
            exhibitors.push({
                id: exhibitorId,
                name: exhibitorName,
                logo: getExhibitorIcon(exhibitorUuid),
                voucherTypes: [voucherType]
            });
        }

        return exhibitors;
    }, [] as Exhibitor[]);

    return exhibitors;
};

const findAllExhibitorsByBalance = async (): Promise<Balance[]> => {
    const { data } = await api.get<Response<ExhibitorVoucherBalance[]>>('vouchers-available/balance');

    if (Object.keys(data).length === 0)
        return [];

    const balances = data.data.reduce((balances, exhibitorVoucherBalance) => {
        const {
            dueDate,
            exhibitorId,
            exhibitorUuid,
            exhibitorName,
            voucherTypeId,
            voucherTypeName,
            amount
        } = exhibitorVoucherBalance;

        const exhibitor: Exhibitor = {
            id: exhibitorId,
            name: exhibitorName,
            logo: getExhibitorIcon(exhibitorUuid),
            voucherTypes: []
        };

        const voucherType: VoucherType = {
            id: voucherTypeId,
            name: voucherTypeName,
            amount
        };

        const balanceIndex = balances.findIndex(balance => balance.dueDate === dueDate);

        if (balanceIndex !== -1) {
            const balance = balances[balanceIndex];

            const exhibitorIndex = balance.exhibitors.findIndex(exhibitor => exhibitor.id === exhibitorId);

            if (exhibitorIndex !== -1) {
                const exhibitor = balance.exhibitors[exhibitorIndex];

                balance.exhibitors[exhibitorIndex] = {
                    ...exhibitor,
                    voucherTypes: [...exhibitor.voucherTypes, voucherType]
                };
            } else {
                balance.exhibitors.push({
                    ...exhibitor,
                    voucherTypes: [voucherType]
                });
            }
        } else {
            balances.push({
                dueDate,
                exhibitors: [({
                    ...exhibitor,
                    voucherTypes: [voucherType]
                })]
            });
        }

        return balances;
    }, [] as Balance[]);

    return balances;
};

export { findAllExhibitors, findAllExhibitorsByBalance };